import { FtTimePipe } from './ft-time.pipe';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [FtTimePipe],
  providers: [FtTimePipe],
  exports: [FtTimePipe]
})
export class FtTimePipeModule { }